import styled from 'styled-components';

export const ExhibitionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  padding-top: 100px;
`;

export const ArticleContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  padding-top: 110px;

  @media (max-width: 768px) {
    padding-top: 90px;
  }
`;

export const TextContainer = styled.div`
  max-width: 960px;
  margin: 0 auto;
`;
export const InterviewContainer = styled.div`
  max-width: 960px;
  margin: 0 auto;
    p {
    margin: 10px 0;
    font-size: 16px;
    line-height: 1.3;
      }
    a{
      text-decoration: underline;

    }
`;

export const HeroImage = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 20px;
  cursor: pointer;
`;

export const HeroCaption = styled.p`
  font-size: 14px;
  color: #666;
  text-align: left;
  margin-bottom: 40px;
`;

export const FeatureImage = styled.img`
  width: 70%;
  height: auto;
  margin: 40px auto;
  display: block;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FeatureCaption = styled.p`
  font-size: 14px;
  color: #666;
  text-align: center;
  margin-bottom: 40px;
`;

export const PageTitle = styled.h3`
  font-size: 32px;
  font-weight: 500;
  margin: 40px 0 20px;
  text-align: center;
  `;
export const Byline = styled.h3`
    font-size: 24px;
    font-weight: 300;
    margin: 40px 0 20px;
    line-height: 1.5;
    font-style: italic;
    margin-bottom: 60px;

  `;

export const SectionTitle = styled.h3`
  font-size: 24px;
  margin: 40px 0 20px;
  `;

  
export const Author = styled.p`
font-size: 22px;
color: #666;
line-height: 1.6;
margin-bottom: 20px;
text-align: center;
`; 

export const Paragraph = styled.p`
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 30px;
  font-weight: 400;
    a{
      text-decoration: underline;
      color: #007bff;
      font-size: 18px;
      margin-bottom: 20px;
      &:hover {
        color: #000;
      }
    }

`; 

export const List = styled.ul`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 5px;
`; 


export const ListItem = styled.li`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 10px;
    margin-left: 40px;
`; 

export const Quote = styled.li`
  font-size: 16px;
  font-style: italic;
  line-height: 1.6;
  margin-bottom: 5px;
`; 

export const Gallery = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
`;

export const GalleryItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
`;

export const ImageCaption = styled.p`
  font-size: 14px;
  color: #666;
  text-align: center;
  margin-bottom: 1rem;
`;

export const MasonryGallery = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
  margin: 2rem 0;

  &::after {
    content: '';
    flex-grow: 999999999;
  }
`;

export const MasonryItem = styled.div`
  height: 250px;
  flex-grow: 1;
  margin: 4px;
  background: #eee;
  position: relative;
  cursor: pointer;

  @media (max-width: 1200px) {
    height: 220px;
  }

  @media (max-width: 768px) {
    height: 180px;
  }

  @media (max-width: 480px) {
    height: 150px;
  }
`;

export const MasonryImage = styled.img`
  max-width: 100%;
  min-width: 100%;
  height: 100%;
  object-fit: cover;
  vertical-align: bottom;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const MasonryCaption = styled.p`
  font-size: 14px;
  color: #666;
  margin-top: 0.5rem;
  margin-bottom: 0;
`;

export const AudioContainer = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 2rem auto;
  
  audio {
    width: 100%;
    height: 40px;
  }
`;
